// INSTRUMENT: Abstract Reasoning Assessment (Standalone · AXIS Verify Express)
// Science: Cattell-Horn-Carroll (CHC) model · IRT calibrated
// Global & Indian norms: n=7K+ working professionals
// Standards: none claimed; platform-specific validity evidence not yet published
import { ABSTRACT_ITEMS } from "../cab/questionBank.js";
import { scoreCAB } from "../cab/scoring.js";

export const ABSTRACT_NORMS = { overall:{ mean:14.8, sd:3.6, n:1200 } };

export const ABSTRACT_COMPETENCIES = [
  {"id":"sequence","label":"Sequence Recognition","icon":"🔢","items":[0, 1, 2, 3, 4, 5, 6, 7]},
  {"id":"matrix","label":"Matrix Reasoning","icon":"⬛","items":[8, 9, 10, 11, 12, 13, 14, 15]},
  {"id":"analogy","label":"Analogical Reasoning","icon":"🔗","items":[16, 17, 18, 19, 20, 21, 22, 23]}
];

const AbstractReasoning = {
  id:"abstract", name:"Abstract Reasoning Assessment", shortName:"Abstract",
  icon:"🔷", color:"#0891b2", bg:"#ecfeff",
  description:"Measures ability to identify patterns, rules and relationships in visual sequences. Assesses fluid intelligence — the ability to reason with novel information independent of prior knowledge. Equivalent to SHL Verify Inductive Reasoning.",
  desc:"24 items · 18 minutes · Auto-scored", publisher:"AXIS360 Express", version:"1.0",
  itemCount:24, items:24,
  timeLimit:18, time:"18 min",
  timeEstimate:"18 min", format:"timed_ability",
  isCognitive:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:['Problem solving with novel information', 'Adapting to new processes and systems', 'Innovation and creative reasoning', 'Performance in analytical and technical roles'],
  questions: ABSTRACT_ITEMS,
  score(answers) {
    const result = scoreCAB("abstract", answers, ABSTRACT_ITEMS);
    const subScores = {};
    ABSTRACT_COMPETENCIES.forEach(comp => {
      const compItems = comp.items.map(i=>ABSTRACT_ITEMS[i]).filter(Boolean);
      const correct = compItems.filter((item,idx)=>answers[comp.items[idx]]===item.ans).length;
      subScores[comp.id] = { correct, total:compItems.length,
        pct:compItems.length?Math.round((correct/compItems.length)*100):0 };
    });
    return { ...result, subScores, scales:{ abstract:result.percentile } };
  },
  nineboxAxes:{ x:{label:"Abstract",scaleIds:["abstract"]}, y:{label:"Abstract",scaleIds:["abstract"]} },
};
export default AbstractReasoning;
